// Based on https://stackoverflow.com/questions/36862334/get-viewport-window-height-in-reactjs/36862446#36862446 -ML

import { useEffect, useState } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export function useIsMobile() {
  const windowDimensions = useWindowDimensions();
  // The breakpoint here should match with the used CSS media queries in ModibleOrNarrower()
  if (windowDimensions.width <= 767) {
    return true;
  } else {
    return false;
  }
}
